
    import { h } from 'vue';
    import { normalizeSlotChildren } from '@/Utils/SlotUtility';

    export default {
        props: {
            title: { type: String, default: 'There is nothing to show.' },
            isBordered: { type: Boolean, default: false },
            isTall: { type: Boolean, default: false },
        },
        render() {
            const { class: attrsClass, ...attrs } = this.$attrs;
            const title = h('span', { class: 'gfu-bt gfu-bt--b2 _mb-1 _mt-1 _pb-1 _pt-1' }, this.title);
            const normalizedChildren = normalizeSlotChildren(this.$slots.default);

            return h(
                'div',
                {
                    ...attrs,
                    class: [
                        'gfua-empty-state',
                        {
                            'gfua-empty-state--bordered': this.isBordered,
                            'gfua-empty-state--tall': this.isTall,
                        },
                        attrsClass,
                    ],
                },
                [title, ...normalizedChildren]);
        },
    };
